export * from './Pagination';
export type {
    ButtonItem as PaginationButtonItem,
    PaginationPagePropsGetter,
    PageItem as PaginationPageItem,
    PaginationPageComponent,
    PaginationProps,
} from './types';
